import React from 'react';
import { cn } from '../index';

export interface PageHeaderProps {
  title: string;
  description?: string;
  badge?: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
}

export const PageHeader: React.FC<PageHeaderProps> = ({ title, description, badge, actions, className }) => (
  <div className={cn('flex flex-col sm:flex-row sm:items-center justify-between gap-2.5 sm:gap-3', className)}>
    <div className="min-w-0">
      <div className="flex items-center gap-2 flex-wrap">
        <h1 className="text-xl sm:text-2xl font-medium tracking-tight text-[var(--fg)]">{title}</h1>
        {badge}
      </div>
      {description && <p className="text-[var(--fg-muted)] text-sm mt-0.5">{description}</p>}
    </div>
    {actions && <div className="flex items-center gap-2 flex-wrap">{actions}</div>}
  </div>
);
